/**
 * Lista zmian pokazywana w oknie „Co nowego” (`WhatsNewDialog`). Najnowszy wpis na górze.
 *
 * `id` pierwszego wpisu to wersja, którą gracz może odhaczyć jako przeczytaną — nowy wpis
 * z innym `id` pokazuje okno ponownie każdemu. Drugie wdrożenie tego samego dnia dostaje
 * więc własne `id` (np. `2026-09-24-2`), a nie dopisek do istniejącego wpisu.
 * Tekst pisany dla gracza, nie dla programisty — bez nazw plików i commitów.
 */
export interface ChangelogEntry {
  readonly id: string;
  /** Data wdrożenia, `RRRR-MM-DD`. */
  readonly date: string;
  readonly items: readonly string[];
}

export const CHANGELOG: readonly ChangelogEntry[] = [
  {
    id: '2026-09-24-4',
    date: '2026-09-24',
    items: [
      '„Anuluj partię” przy rozstawianiu floty — rozmyśliłeś się przed pierwszym strzałem? Partia znika bez porażki i nie liczy się do statystyk.',
      'Stare, nieużywane pokoje z kodem zostały posprzątane.',
      'Krótszy nagłówek planszy przeciwnika — „Wróg” — i delikatniejsze zaznaczenie jego ostatniej serii.',
    ],
  },
  {
    id: '2026-09-24-3',
    date: '2026-09-24',
    items: [
      'Pomoc pod przyciskiem „?” w prawym górnym rogu: zasady, sterowanie, zapraszanie i obsługa aplikacji — z animowanymi przykładami.',
    ],
  },
  {
    id: '2026-09-24-2',
    date: '2026-09-24',
    items: [
      'Prostsze lobby: jedna karta z listą graczy i przyciskiem „Zagraj z botem”.',
      'Partię z drugą osobą zaczynasz, wyzywając ją z listy — bez kodów zaproszenia.',
      'Znajomych bez konta zaprosisz linkiem rejestracyjnym z „Moje konto”.',
      'Numer i data wersji aplikacji w stopce strony — łatwo sprawdzić, czy masz najnowszą.',
    ],
  },
  {
    id: '2026-09-24',
    date: '2026-09-24',
    items: [
      'Lista „Gracze” w lobby — wyzwij kogokolwiek, widać, kto jest online, a kto w trakcie partii.',
      'Zaproszenie do partii jednym przyciskiem „Wyślij zaproszenie…” (komunikatory, WhatsApp, SMS).',
      'Powrót do trwającej partii z innego urządzenia albo po zamknięciu karty — pasek „Wróć do gry”.',
      'Zatopiony statek przeciwnika jest zacieniowany już w trakcie partii.',
      'Ostatnia seria strzałów przeciwnika zaznaczona na Twojej planszy.',
      'Zamiast przycisku „Ognia!” — status tury przy planszy przeciwnika; strzał drugim dotknięciem pola.',
      'To okno z listą zmian.',
    ],
  },
  {
    id: '2026-09-14',
    date: '2026-09-14',
    items: [
      'Wyzwania i propozycje rewanżu w okienku widocznym z każdego ekranu.',
      'Informacja, gdy wyzwany gracz jest akurat w trakcie innej partii.',
      'Przeciwnik, który zniknie przy rozstawianiu floty, po 2 minutach oddaje partię walkowerem.',
      'Nowy układ strony „Moje konto”, zmiana hasła w osobnym okienku.',
    ],
  },
  {
    id: '2026-09-13',
    date: '2026-09-13',
    items: [
      'Bilans pojedynków z każdym przeciwnikiem w lobby.',
      'Obrót postawionego statku podwójnym dotknięciem.',
      'Plansza przeciwnika przygasa, gdy nie Twoja kolej.',
      'Podpowiedź dostępności nicku przy rejestracji.',
      'Pewniejsze wznawianie połączenia i powrót do lobby ze starych linków do partii.',
    ],
  },
  {
    id: '2026-09-11',
    date: '2026-09-11',
    items: [
      'Gra z botem na trzech poziomach trudności.',
      'Rejestracja przez link zaproszenia od znajomego.',
      'Ranking i szukanie przeciwnika w grze rankingowej.',
      'Ostatni przeciwnicy, ulubieni i wyzwania na pojedynek.',
      'Strona „Moje konto”: statystyki, historia partii, zmiana hasła, instalacja aplikacji.',
    ],
  },
];
